import React, { Component } from 'react';
import '../ImprovingTabs.css';
import _ from 'lodash';

class ImprovingTabsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        }
    }

    render() {
        
        let list = this.props.data.map((item, key) => {

            return(
                <div className="addedValues" key={key}>
                    <label>{item.name}</label>
                    <div>
                        <i className="fa fa-minus minus-icon" onClick={()=>this.props.onValueDelete(item, this.props.type, this.props.groupId, this.props.segmentId)}
                        ></i>
                    </div>
                </div>
            )

        });

        return (
            <div className='improving-tabs-content'>
                {list}
            </div>
        )
    }
}
export default (ImprovingTabsList);



// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/Improving/ImprovingTabs/ImprovingTabsList/ImprovingTabsList.jsx